<div class="dashboard-module-item-preview-container" fxLayoutGap="20px">
  <div class="dashboard-module-item-preview" fxLayout="column" fxLayoutAlign="start stretch">
    <div class="dashboard-module-item-preview__notch-background" fxLayout="column" fxLayoutAlign="start stretch">
      <div class="dashboard-module-item-preview__notch" fxFlexAlign="center"></div>
    </div>
    <div style="height: 100px">
      <div class="dashboard-module-item-preview__module-header">
        <div class="dashboard-module-item-preview__module-header__header-left-side">
          <div class="dashboard-module-item-preview__module-header__home-button">
            <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.0003 0L0.666992 10V30H9.00032V18.3333H19.0003V30H27.3337V10L14.0003 0Z" fill="white" />
            </svg>
          </div>
        </div>
        <div class="dashboard-module-item-preview__module-header__header-center">
          <div class="dashboard-module-item-preview__module-header__study-title">
            {{ studyTitle }}
          </div>
        </div>
      </div>
      <div class="dashboard-module-item-preview__progress-background" fxFlexAlign="stretch">
        <div class="dashboard-module-item-preview__progress-background__progress-number-container">
          <div class="dashboard-module-item-preview__progress-background__progress-value-number">0%</div>
        </div>
        <div class="dashboard-module-item-preview__progress-background__progress-bar-container"></div>
      </div>
    </div>
    <div *ngIf="!ivyElements.hideInfo">
      <div class="dashboard-module-item-preview__info" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="30">
        <div class="dashboard-module-item-preview__info-title" [innerHTML]="previewQuestion"></div>
        <div
          class="dashboard-module-item-preview__info-description"
          *ngIf="studyType !== StudyType.CC"
          [innerHTML]="previewDescription"
        ></div>
        <div
          *ngIf="
            subType !== ModuleItemAvailableSubType.VIDEO_AUDIO &&
            subType !== ModuleItemAvailableSubType.GRAPH &&
            subType !== ModuleItemAvailableSubType.QUADRANT
          "
          class="dashboard-module-item-preview__media"
        >
          <img
            class="dashboard-module-item-preview__media-image"
            *ngIf="(uploadCompleted$ | async) || this.previewImage"
            [src]="publicUrl + previewImage"
            [alt]="previewImage"
          />
          <iframe
            *ngIf="previewVideo?.isVisible && previewVideo?.url"
            width="100%"
            allowfullscreen
            [src]="prepareApiVideoUrl(previewVideo.url) | dashboardSafe: SANITIZER_TYPES.RESOURCE_URL"
          >
          </iframe>
        </div>
      </div>
    </div>
    <div
      class="dashboard-module-item-preview__module-item-background"
      fxLayout="column"
      fxLayoutAlign="start stretch"
      *ngIf="subType"
    >
      <div
        class="dashboard-module-item-preview__inputs"
        fxLayout="column"
        fxLayoutAlign="space-around stretch"
        *ngIf="subType === ModuleItemAvailableSubType.INPUT"
      >
        <div class="dashboard-module-item-preview__your-answer-text">Your answer</div>
        <div>
          <form autocomplete="off">
            <input class="number-input" type="number" placeholder="Type your answer here" />
          </form>
        </div>
      </div>
      <div
        class="dashboard-module-item-preview__number-choice"
        fxLayout="column"
        fxLayoutAlign="space-around stretch"
        *ngIf="subType === ModuleItemAvailableSubType.SINGLE_CHOICE"
      >
        <div class="dashboard-module-item-preview__your-answer-text">Your answer</div>
        <span class="dashboard-module-item-preview__number-choice-left-label">{{ previewLabelLeft }}</span>
        <div class="dashboard-module-item-preview__number-choice-numbers">
          <a
            *ngFor="let number of previewNumberChoices"
            (click)="previewSelectedNumber = number"
            [class]="
              previewSelectedNumber === number
                ? 'dashboard-module-item-preview__number-choice-numbers-option-holder selected-number'
                : 'dashboard-module-item-preview__number-choice-numbers-option-holder'
            "
          >
            <span>
              {{ number }}
            </span>
          </a>
          <a
            *ngIf="previewNumberChoices[previewNumberChoices.length - 1] < previewMaxValue"
            class="dashboard-module-item-preview__number-choice-numbers-option-holder"
          >
            <span>...</span>
          </a>
        </div>
        <div fxLayout="row" fxLayoutAlign="end">
          <span class="dashboard-module-item-preview__number-choice-right-label">{{ previewLabelRight }}</span>
        </div>
      </div>
      <div
        class="dashboard-module-item-preview__slider"
        fxLayout="column"
        fxLayoutAlign="space-around stretch"
        *ngIf="subType === ModuleItemAvailableSubType.SLIDER"
      >
        <div class="dashboard-module-item-preview__your-answer-text">Your answer</div>
        <mat-slider
          [min]="previewMinValue"
          [max]="previewMaxValue"
          [step]="previewStepSize"
          [value]="previewMaxValue"
          thumbLabel
        ></mat-slider>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="labels">
          <span>{{ previewLabelLeft }}</span>
          <span>{{ previewLabelRight }}</span>
        </div>
      </div>
      <div *ngIf="subType === ModuleItemAvailableSubType.DROPDOWN">
        <div class="number-dropdown-container">
          <div class="dashboard-module-item-preview__your-answer-text">Your answer</div>
          <div class="number-dropdown-select-container" (click)="openNumberDropdown()">
            <div class="number-dropdown-selected">
              {{ selectedNumber ? selectedNumber : 'Select your answer' }}
            </div>
            <div class="number-dropdown-button">
              <svg
                *ngIf="!expand"
                width="23"
                height="14"
                viewBox="0 0 23 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M2.7025 0L11.5 8.65317L20.2975 0L23 2.66397L11.5 14L0 2.66397L2.7025 0Z" fill="white" />
              </svg>
              <svg
                *ngIf="expand"
                width="23"
                height="14"
                viewBox="0 0 23 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.2975 14L11.5 5.34683L2.7025 14L2.32891e-07 11.336L11.5 -1.00536e-06L23 11.336L20.2975 14Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
          <div *ngIf="expand" class="number-dropdown-option-container">
            <div
              *ngFor="let choice of previewNumberChoices || previewChoices"
              class="number-dropdown-option"
              (click)="selectOption(choice)"
            >
              {{ choice }}
            </div>
            <div
              *ngIf="previewNumberChoices && previewNumberChoices[previewNumberChoices.length - 1] < previewMaxValue"
              class="number-dropdown-option"
            >
              ...
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="subType === ModuleItemAvailableSubType.MULTIPLE_CHOICE">
        <div class="dashboard-module-item-preview__your-answer-text">Your answer</div>
        <div class="dashboard-module-item-preview__checkbox-choices">
          <div *ngFor="let choice of previewChoices; let i = index">
            <label class="dashboard-module-item-preview__checkbox-choices-container" for="{{ i }}">
              <input
                class="dashboard-module-item-preview__checkbox-choices-choice-checkbox"
                type="checkbox"
                id="{{ i }}"
              />
              <span class="dashboard-module-item-preview__checkbox-choices-choice-checkbox-button"></span>
              <div class="dashboard-module-item-preview__checkbox-choices-choice-text">
                {{ choice }}
              </div>
            </label>
          </div>
          <div *ngIf="previewAllowOther" class="dashboard-module-item-preview__checkbox-choices-container">
            <form>
              <label>
                <input
                  class="dashboard-module-item-preview__checkbox-choices-choice-checkbox"
                  type="checkbox"
                  [checked]="otherAnswer.value.length"
                  disabled
                />
                <span class="dashboard-module-item-preview__checkbox-choices-choice-checkbox-button"></span>
                <div class="dashboard-module-item-preview__checkbox-choices-other">
                  <input
                    class="dashboard-module-item-preview__checkbox-choices-other-input"
                    type="text"
                    #otherAnswer
                    placeholder="Other"
                  />
                </div>
              </label>
            </form>
          </div>
        </div>
      </div>
      <div
        class="dashboard-module-item-preview__inputs"
        fxLayout="column"
        fxLayoutAlign="space-around stretch"
        *ngIf="subType === ModuleItemAvailableSubType.SINGLE_LINE"
      >
        <div class="dashboard-module-item-preview__your-answer-text">Your answer</div>
        <form fxLayout="column">
          <input class="single-line-input" #singleLineAnswer placeholder="Type your answer here" />
        </form>
        <div
          class="dashboard-module-item-preview__inputs-chars-count"
          *ngIf="previewMaxChars"
          fxLayout="column"
          fxFlexAlign="end"
        >
          {{ singleLineAnswer.value.toString().length }}/{{ previewMaxChars }}
        </div>
      </div>
      <div
        class="dashboard-module-item-preview__inputs"
        fxLayout="column"
        fxLayoutAlign="space-around stretch"
        *ngIf="subType === ModuleItemAvailableSubType.MULTI_LINE"
      >
        <div class="dashboard-module-item-preview__your-answer-text">Your answer</div>
        <mat-form-field appearance="fill" fxLayout="column">
          <mat-label>Type your answer here</mat-label>
          <textarea
            #multiLineAnswer
            class="dashboard-module-item-preview__inputs-text-area"
            matInput
            rows="2"
          ></textarea>
        </mat-form-field>
        <div
          class="dashboard-module-item-preview__inputs-chars-count"
          *ngIf="previewMaxChars"
          fxLayout="column"
          fxFlexAlign="end"
        >
          {{ multiLineAnswer.value.toString().length }}/{{ previewMaxChars }}
        </div>
      </div>
      <div
        class="dashboard-module-item-preview__section--yes_no_section"
        *ngIf="subType === ModuleItemAvailableSubType.YES_NO"
      >
        <div class="dashboard-module-item-preview__your-answer-text">Your answer</div>
        <div class="buttons">
          <button
            mat-button
            class="dashboard-module-item-preview__section--yes_no"
            [ngClass]="[YesNo ? 'active' : '']"
            fxFlexAlign="end"
            (click)="setYesNo(true)"
          >
            {{ previewYesLabel }}
          </button>
          <button
            mat-button
            class="dashboard-module-item-preview__section--yes_no"
            [ngClass]="[YesNo === false ? 'active' : '']"
            fxFlexAlign="end"
            (click)="setYesNo(false)"
          >
            {{ previewNoLabel }}
          </button>
        </div>
      </div>
      <div class="dashboard-module-item-preview__section" *ngIf="subType === ModuleItemAvailableSubType.YES_NO_OTHER">
        <div fxLayout="row wrap" fxLayoutAlign="space-around center">
          <button
            mat-button
            class="dashboard-module-item-preview__actions"
            fxFlexAlign="end"
            (click)="changeOtherInputVisibility(false)"
          >
            {{ previewYesLabel }}
          </button>
          <button
            mat-button
            class="dashboard-module-item-preview__actions"
            fxFlexAlign="end"
            (click)="changeOtherInputVisibility(true)"
          >
            {{ previewNoLabel }}
          </button>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-around stretch" *ngIf="isVisibleOtherInput">
          <mat-form-field fxLayout="column">
            <input type="text" matInput placeholder="No, other.." />
          </mat-form-field>
        </div>
      </div>
      <div
        class="dashboard-module-item-preview__likert-scale-choices"
        *ngIf="subType === ModuleItemAvailableSubType.LIKERT"
      >
        <div class="dashboard-module-item-preview__your-answer-text">Your answer</div>
        <mat-radio-group fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="30px">
          <mat-radio-button
            class="dashboard-module-item-preview__likert-scale-choices-choice"
            fxLayout="column"
            *ngFor="let choice of previewChoices; let i = index"
            [value]="i"
            aria-label="Select an option"
          >
            {{ choice }}
          </mat-radio-button>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="dashboard-module-item-preview__likert-scale-choices-other"
            *ngIf="previewAllowOther"
          >
            <mat-radio-button
              fxLayout="column"
              fxFlex="10"
              *ngIf="previewAllowOther"
              value="other"
              aria-label="Select an option"
            >
            </mat-radio-button>
            <mat-form-field *ngIf="previewAllowOther" fxLayout="column" fxFlex="90">
              <input matInput placeholder="Other" />
            </mat-form-field>
          </div>
        </mat-radio-group>
      </div>
      <div
        class="dashboard-module-item-preview__video-audio"
        *ngIf="subType === ModuleItemAvailableSubType.VIDEO_AUDIO && previewAudioVideo"
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <video
          *ngIf="previewAudioVideo?.toString().startsWith(publicUrl + 'videos'); else audioPreview"
          controls
          width="100%"
          loop
          preload="auto"
        >
          <source [src]="previewAudioVideo" />
          <p>
            Your browser doesn't support HTML video. Here is a
            <a [href]="previewAudioVideo">link to the video</a> instead.
          </p>
        </video>
        <ng-template #audioPreview>
          <audio controls>
            <source [src]="previewAudioVideo" />
            <p>
              Your browser doesn't support HTML5 audio. Here is a
              <a [href]="previewAudioVideo">link to the audio</a> instead.
            </p>
          </audio>
        </ng-template>
      </div>
      <div *ngIf="subType === ModuleItemAvailableSubType.GRAPH">
        <canvas
          baseChart
          height="250"
          width="275"
          [datasets]="previewGraphData"
          [labels]="previewGraphLabels"
          [chartType]="'line'"
          [options]="previewGraphOptions"
        ></canvas>
      </div>
      <div *ngIf="subType === ModuleItemAvailableSubType.IVY">
        <div class="dashboard-module-item-preview__your-answer-text">Answer in the pop-up.</div>
        <div class="dashboard-module-item-preview__pop-up-button">Open pop-up</div>
      </div>
      <div *ngIf="subType === ModuleItemAvailableSubType.QUADRANT">
        <div class="dashboard-module-item-preview__your-answer-text">Your answer</div>
        <img
          class="dashboard-module-item-preview__media-image"
          *ngIf="(uploadCompleted$ | async) || previewQuadrantImage"
          [src]="
            previewQuadrantImage === MODULE_ITEM_DEFAULT_QUADRANT_IMAGE || !previewQuadrantImage
              ? MODULE_ITEM_DEFAULT_QUADRANT_IMAGE
              : publicUrl + previewQuadrantImage
          "
          [alt]="previewQuadrantImage"
        />
      </div>
      <div *ngIf="subType === ModuleItemAvailableSubType.IMAGE" class="dashboard-module-item-preview__camera-image">
        <div class="dashboard-module-item-preview__your-answer-text">Answer this question by taking a picture</div>
        <div class="camera">
          <div class="camera-button">
            <svg
              class="camera-logo"
              width="60"
              height="54"
              viewBox="0 0 60 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.2507 0.833336L15.9132 6.66667H6.66732C3.45898 6.66667 0.833984 9.29167 0.833984 12.5V47.5C0.833984 50.7083 3.45898 53.3333 6.66732 53.3333H53.334C56.5423 53.3333 59.1673 50.7083 59.1673 47.5V12.5C59.1673 9.29167 56.5423 6.66667 53.334 6.66667H44.0882L38.7507 0.833336H21.2507ZM30.0007 44.5833C21.9507 44.5833 15.4173 38.05 15.4173 30C15.4173 21.95 21.9507 15.4167 30.0007 15.4167C38.0507 15.4167 44.584 21.95 44.584 30C44.584 38.05 38.0507 44.5833 30.0007 44.5833Z"
                fill="white"
              />
            </svg>
            <svg
              class="camera-logo-circle"
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99935 19.3333C15.154 19.3333 19.3327 15.1547 19.3327 10C19.3327 4.84535 15.154 0.666672 9.99935 0.666672C4.84469 0.666672 0.666016 4.84535 0.666016 10C0.666016 15.1547 4.84469 19.3333 9.99935 19.3333Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
      <button
        mat-button
        class="dashboard-module-item-preview__actions"
        fxFlexAlign="end"
        *ngIf="type === ModuleItemAvailableType.INFO"
      >
        {{ previewButtonLabel }}
      </button>
      <div
        class="dashboard-module-item-preview__recording"
        fxLayout="column"
        fxLayoutAlign="end center"
        fxFlex="100"
        *ngIf="subType === ModuleItemAvailableSubType.AUDIO_RECORDING"
      >
        <div class="dashboard-module-item-preview__your-answer-text">Answer this question with a recording</div>
        <div class="dashboard-module-item-preview__recording__button-start">
          <svg width="45px" height="65px" viewBox="0 0 56 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill="white"
              d="M28 48C34.64 48 39.96 42.64 39.96 36L40 12C40 5.36 34.64 0 28 0C21.36 0 16 5.36 16 12V36C16 42.64
            21.36 48 28 48ZM49.2 36C49.2 48 39.04 56.4 28 56.4C16.96 56.4 6.8 48 6.8 36H0C0 49.68 10.88 60.92 24
            62.88V76H32V62.88C45.12 60.96 56 49.68 56 36H49.2Z"
            />
          </svg>
        </div>
      </div>
      <div *ngIf="subType === ModuleItemAvailableSubType.ORBITS || subType === ModuleItemAvailableSubType.NETWORK">
        <div class="dashboard-module-item-preview__your-answer-text">Answer in the pop-up.</div>
        <div class="dashboard-module-item-preview__pop-up-button">Open pop-up</div>
      </div>
    </div>
  </div>
  <div
    class="dashboard-module-item-preview"
    style="background-color: {{ color }}"
    fxLayout="column"
    fxLayoutAlign="start stretch"
    *ngIf="subType === ModuleItemAvailableSubType.ORBITS || subType === ModuleItemAvailableSubType.NETWORK"
  >
    <div class="dashboard-module-item-preview__notch-background" fxLayout="column" fxLayoutAlign="start stretch">
      <div class="dashboard-module-item-preview__notch" fxFlexAlign="center"></div>
    </div>
    <div class="dashboard-module-item-preview__orbit-network">
      <div class="dashboard-module-item-preview__orbit-network-header">
        <div class="dashboard-module-item-preview__orbit-network-main-question" [innerHTML]="previewQuestion"></div>
        <div
          class="dashboard-module-item-preview__orbit-network-description-question"
          [innerHTML]="previewDescription"
        ></div>
      </div>
      <div class="dashboard-module-item-preview__orbit-network-canvas-background">
        <div class="dashboard-module-item-preview__orbit-network-canvas-container">
          <dashboard-orbits-canvas-preview [initialNumberOfOrbits]="moduleItem ? moduleItem.numberOrbits : 0">
          </dashboard-orbits-canvas-preview>
          <div
            class="orbits-canvas-preview_actions"
            *ngIf="subType === ModuleItemAvailableSubType.NETWORK"
            fxLayout="row"
            fxLayoutAlign="space-around center"
          >
            <button class="dashboard-module-item-preview__orbit-network-add-button">Add network item</button>
          </div>
          <div
            class="orbits-canvas-preview_actions"
            *ngIf="subType === ModuleItemAvailableSubType.ORBITS"
            fxLayout="row"
            fxLayoutAlign="space-around center"
          >
            <button class="dashboard-module-item-preview__orbit-network-add-button">Add orbit item</button>
          </div>
        </div>
        <div class="dashboard-module-item-preview__orbit-network-close-button-container">
          <button class="dashboard-module-item-preview__orbit-network-close-button">Save answer</button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="dashboard-module-item-preview"
    style="background-color: {{ color }}"
    fxLayout="column"
    fxLayoutAlign="start stretch"
    *ngIf="subType === ModuleItemAvailableSubType.ORBITS || subType === ModuleItemAvailableSubType.NETWORK"
  >
    <div class="dashboard-module-item-preview__notch-background" fxLayout="column" fxLayoutAlign="start stretch">
      <div class="dashboard-module-item-preview__notch" fxFlexAlign="center"></div>
    </div>
    <div class="dashboard-module-item-preview__orbit-network">
      <div class="dashboard-module-item-preview__orbit-network-header">
        <div class="dashboard-module-item-preview__orbit-network-main-question" [innerHTML]="previewQuestion"></div>
        <div
          class="dashboard-module-item-preview__orbit-network-description-question"
          [innerHTML]="previewDescription"
        ></div>
      </div>
      <div class="dashboard-module-item-preview__orbit-network-canvas-background">
        <dashboard-orbits-config-preview
          *ngIf="subType === ModuleItemAvailableSubType.ORBITS"
          [initialOrbitItems]="moduleItem ? moduleItem.orbitItems : []"
        >
        </dashboard-orbits-config-preview>
        <dashboard-network-config-preview
          *ngIf="subType === ModuleItemAvailableSubType.NETWORK"
          [initialAttributes]="moduleItem ? moduleItem.attributes : []"
          fxLayout="column"
          fxFlex="100"
        >
        </dashboard-network-config-preview>
      </div>
    </div>
  </div>
  <div
    class="dashboard-module-item-preview"
    style="background-color: {{ color }}"
    fxLayout="column"
    fxLayoutAlign="start stretch"
    *ngIf="subType === ModuleItemAvailableSubType.IVY"
  >
    <div class="dashboard-module-item-preview__notch-background" fxLayout="column" fxLayoutAlign="start stretch">
      <div class="dashboard-module-item-preview__notch" fxFlexAlign="center"></div>
    </div>
    <div class="dashboard-module-item-preview__ivy" fxLayout="column" fxLayoutAlign="space-between center">
      <div
        #topZone
        id="topZone"
        fxFlex="15"
        class="zone top"
        fxLayout="column"
        fxLayoutAlign="center center"
        (click)="onIvyZoneClick($event)"
      >
        <div class="dashboard-module-item-preview__ivy-zone-group">
          {{ ivyElements.translations[ivyElements.selectedLanguageCode]?.top_zone_group || '' }}
        </div>
        <div class="dashboard-module-item-preview__ivy-zone-word">
          {{ ivyElements.translations[ivyElements.selectedLanguageCode]?.top_zone_word || '' }}
        </div>
      </div>
      <div #dragWord id="dragWord" fxLayout="column" fxLayoutAlign="center center" style="text-align: center">
        {{ ivyElements.translations[ivyElements.selectedLanguageCode]?.drag_word || '' }}
      </div>
      <div
        #bottomZone
        id="bottomZone"
        fxFlex="15"
        class="zone bottom"
        fxLayout="column"
        fxLayoutAlign="center center"
        (click)="onIvyZoneClick($event)"
      >
        <div class="dashboard-module-item-preview__ivy-zone-group">
          {{ ivyElements.translations[ivyElements.selectedLanguageCode]?.bottom_zone_group || '' }}
        </div>
        <div class="dashboard-module-item-preview__ivy-zone-word">
          {{ ivyElements.translations[ivyElements.selectedLanguageCode]?.bottom_zone_word || '' }}
        </div>
      </div>
    </div>
  </div>
</div>
